(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService', 'UserGroup', 'paginationConstants'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService, UserGroup, paginationConstants) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.userGroups = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        UserGroup.query({
            size: paginationConstants.userGroupSelectionItemsPerPage
        }, onSuccess, onError);

        function onSuccess(userGroups) {
            vm.userGroups = userGroups.map(function(data){return data.name});
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
